import axios from "axios";
import store from '../store/index.js'
import router from '../router'
import {
  Message
} from "element-ui";
// axios 配置
const base = process.env.VUE_APP_BASE_API;
axios.defaults.timeout = 1000000;
axios.defaults.headers.post['Content-Type'] = 'application/json';

// POST传参序列化
axios.interceptors.request.use(
  config => {
    config.url = base + config.url;
    const token = localStorage.getItem('token');
    token && (config.headers.token = token);
    return config;
  },
  err => {
    Message.error("参数错误");
    return Promise.reject(err);
  }
);
// 返回状态判断
axios.interceptors.response.use(
  // 请求成功
  res => {
    if (res.status === 200) {
      if (res.data.code) {
        switch (res.data.code) {
          case 200:
            return Promise.resolve(res);
          case 910002:
            Message.error("登录失败的异常token失效，请登录");
            store.dispatch('user/resetToken');
            router.push('/login');
            break;
          case 10002:
            Message.error("请先登录");
            store.dispatch('user/resetToken');
            router.push('/login');
            break;
          case 910003:
            Message.error("不支持的Token");
            store.dispatch('user/resetToken');
            router.push('/login');
            break;
          case 910004:
            Message.error("Token格式错误");
            store.dispatch('user/resetToken');
            router.push('/login');
            break;
          case 910005:
            Message.error("Token签名异常");
            store.dispatch('user/resetToken');
            router.push('/login');
            break;
          case 910006:
            Message.error("Token非法参数");
            store.dispatch('user/resetToken');
            router.push('/login');
            break;
          case 910007:
            Message.error("Token解析异常");
            store.dispatch('user/resetToken');
            router.push('/login');
            break;
          case 910008:
            Message.error("Token校验失败");
            store.dispatch('user/resetToken');
            router.push('/login');
            break;
          case 404:
            Message.error("数据请求异常, 请检查后请重试");
            break;
          case 914000:
            Message.error("权限不足");
            break;
          default:
            Message.error(res.data.msg);
        }
      } else {
        return Promise.resolve(res);
      }
    } else {
      return Promise.reject(res);
    }
  },
  // 请求失败
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 401:
          Message.error("未授权，请登录");
          break;
        case 404:
          Message.error("数据请求异常, 请重试");
          break;
        default:
          Message.error("出错啦");
      }
    }
    return Promise.reject(err);
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res);
    }).catch(err => {
      reject(err);
    })
  });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数
 */
export function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, JSON.stringify(params))
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      })
  });
}

/** 
 * delete方法，对应delete请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数
 */
export function del(url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(`${url}/${params}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      })
  });
}

/**
 * getgetFile方法，对应get请求 下载文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getFile(url, params) {
  return new Promise((resolve, reject) => {
    axios.defaults.responseType = 'blob';
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data);
    })
  });
}